import "core-js/modules/es.promise.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { ref, onMounted, onUnmounted } from "vue";
export function useKeyEnterPressed() {
  /** The event listener which will be fired on keyup event */
  var handleEnterPressed = ref(null);
  /** This callback function will automatically unsubscribe the listener whenever it returns a truthy result.
   *  IMP: It's important to use this callback to ensure the unsubscribing instead of the input function!
   * */
  var enterPressedCb = ref(null);
  onMounted(() => {
    if (!handleEnterPressed.value) return;
    document.addEventListener("keyup", handleEnterPressed.value);
  });
  onUnmounted(() => {
    if (!handleEnterPressed.value) return;
    document.removeEventListener("keyup", handleEnterPressed.value);
  });
  var onEnterPressed = fn => {
    //Initializing the callback function
    enterPressedCb.value = () => __awaiter(this, void 0, void 0, function* () {
      var res = yield fn();
      if (res) handleEnterPressed.value && document.removeEventListener("keyup", handleEnterPressed.value);
    });
    //Initializing the onKeyUp handler!
    handleEnterPressed.value = event => __awaiter(this, void 0, void 0, function* () {
      event.preventDefault();
      if (event.key === "Enter" && enterPressedCb.value) {
        yield enterPressedCb.value();
      }
    });
  };
  return {
    enterPressedCb,
    onEnterPressed
  };
}